import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-black" }, " Contacts ", -1)
const _hoisted_3 = {
  key: 0,
  class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
}
const _hoisted_4 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Contact "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Phone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Contact Type ")
  ])
], -1)
const _hoisted_6 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_9 = { class: "text-sm font-medium text-brand" }
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/contacts/add')))
      }, " Add Contact ")
    ]),
    (_ctx.contacts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass(['hover:bg-gray-50 cursor-pointer']),
                  onClick: ($event: any) => (_ctx.onRowSelection(contact.id))
                }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(contact.properties.firstname) + " " + _toDisplayString(contact.properties.lastname), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(contact.properties.email), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(contact.properties.phone), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.formatContactType(contact.properties.contact_type)), 1)
                ], 8, _hoisted_7))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, " Loading Contacts... "))
  ]))
}